import clsx from 'clsx'

/**
 * Animated placeholder block. Use to fill the space of content that is still
 * loading (e.g. deferred gateway data) so layout doesn't jump. Collectia
 * addition (not part of the Catalyst kit).
 */
export function Skeleton({ className }: { className?: string }) {
  return <div className={clsx('animate-pulse rounded-md bg-zinc-200/70', className)} aria-hidden="true" />
}
